import React from 'react';
import { ButtonCardGroup, ButtonItem } from '../ButtonCardGroup';
import styles from '../mortgage.module.scss';

interface ButtonStepInterface {
  title: string;
  customClass: string;
  onclick: (string) => void;
  options: ButtonItem[];
  notes?: string;
}

export const ButtonStep: React.FC<ButtonStepInterface> = ({ customClass, notes, onclick, options, title }) => {
  return (
    <section className={`step ${customClass}`}>
      <h2 className={`${styles.heading} mx-auto text-center font-bold`}>{title}</h2>
      <ButtonCardGroup buttons={options} onClick={onclick} />
      {notes && <div className="mx-auto mt-7 max-w-[440px] text-[15px] leading-normal text-slate-500">{notes}</div>}
    </section>
  );
};
